var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGallery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-images",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-images:not(.animated) .animable {opacity: 0;}svg#freepik_stories-images.animated #freepik--Images--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-images.animated #freepik--Character--inject-2 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2",
    style: {
      transformOrigin: "247.154px 254.48px 0px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.53,270.64a20,20,0,0,1-4.29,1.7,20.18,20.18,0,0,1-4.46,1.21,20,20,0,0,1,4.29-1.7A20.87,20.87,0,0,1,424.53,270.64Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "420.155px 272.095px 0px"
    },
    id: "elavqes94f21m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.28 430.15 313.28 466.49 318.14 466.49 324.67 429.75 313.28 430.15",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "318.975px 448.12px 0px"
    },
    id: "elrtelxevyip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.51 430.15 357.51 466.49 362.38 466.49 368.91 429.75 357.51 430.15",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "363.21px 448.12px 0px"
    },
    id: "elcjex7xmsffb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.82 430.15 412.82 466.49 407.96 466.49 401.43 429.75 412.82 430.15",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "407.125px 448.12px 0px"
    },
    id: "elahnigysfkdm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.9 430.15 443.9 466.49 439.03 466.49 432.5 429.75 443.9 430.15",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "438.2px 448.12px 0px"
    },
    id: "el29w38tvjbdr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.67,350.22s-19.22-5.55-24.53,1.84-5.86,78.6-5.86,78.6,34.31.62,34.94,0S343.67,350.22,343.67,350.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "330.777px 389.578px 0px"
    },
    id: "eloemtlo38bma",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.92,417.67l.84-123.46A28.61,28.61,0,0,0,415,265.41H369.7a28.24,28.24,0,0,0-28.23,28.91l2.91,123.35Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "392.611px 341.54px 0px"
    },
    id: "elshhgntg3pqe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.92,417.67s-17.47-25.77-38-26.62-64.79,0-64.79,0-19.62.75-21,25.05v14.33H442.92Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "381.025px 410.551px 0px"
    },
    id: "elqy2vzoj5ile",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.75,391.79l-50.81-.26c-5.31,0-11.34-.68-16.48.78-15.15,4.29-17.37,23.66-16.17,37,0,.54-.8.54-.85,0-1-11.21.17-26.9,9.75-34.36,5.53-4.3,11.95-4.37,18.55-4.34l56,.3a.43.43,0,0,1,0,.85Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "360.626px 410.161px 0px"
    },
    id: "eljkjwzepmki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.45,269.27l.33-.12c.21-.06.54-.18,1-.28s1-.18,1.63-.28,1.39-.17,2.24-.24c3.37-.29,8.26-.47,14.31-.51,3,0,6.34,0,9.89,0a102.59,102.59,0,0,1,11.35.52,51.72,51.72,0,0,1,6.07,1.09,28.07,28.07,0,0,1,6.07,2.16,24.28,24.28,0,0,1,9.49,9.51,16.07,16.07,0,0,1,1.26,3.25,23.79,23.79,0,0,1,.52,3.39c.27,2.23.48,4.43.7,6.6.42,4.33.72,8.52,1,12.51.5,8,.72,15.18.87,21.22s.19,10.94.22,14.32c0,1.66,0,3,0,3.89,0,.42,0,.76,0,1a1.35,1.35,0,0,1,0,.35,1.6,1.6,0,0,1,0-.35c0-.25,0-.59,0-1,0-.92-.07-2.23-.12-3.89-.1-3.41-.23-8.29-.39-14.31s-.45-13.23-1-21.2c-.26-4-.58-8.17-1-12.49-.22-2.16-.44-4.36-.7-6.59a24.16,24.16,0,0,0-.51-3.32,15.86,15.86,0,0,0-1.23-3.14,22.07,22.07,0,0,0-4-5.37,22.85,22.85,0,0,0-5.22-3.93,27.85,27.85,0,0,0-5.95-2.13,52.17,52.17,0,0,0-6-1.1,106.49,106.49,0,0,0-11.3-.56c-3.55-.06-6.86-.1-9.88-.1-6,0-10.93.11-14.3.34l-2.23.2-1.63.23c-.43.07-.75.18-1,.23A1.37,1.37,0,0,1,355.45,269.27Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "388.931px 307.743px 0px"
    },
    id: "elpln233v18t7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.91,301.74a13.91,13.91,0,0,1-3.44,1.48,13.43,13.43,0,0,1-3.6,1,13.72,13.72,0,0,1,3.43-1.48A13.45,13.45,0,0,1,427.91,301.74Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "424.39px 302.98px 0px"
    },
    id: "elmxdbctojf1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.09,308.83c0,.14-.74.23-1.62.19s-1.61-.19-1.6-.33.73-.23,1.62-.19S424.09,308.69,424.09,308.83Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "422.48px 308.76px 0px"
    },
    id: "eleiew73shlr5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,306.47s.14-.13.47-.16a2,2,0,0,1,1.31.46,1.91,1.91,0,0,1,.65,2,2.24,2.24,0,0,1-1.94,1.63,2.3,2.3,0,0,1-2.15-1.33,2.1,2.1,0,0,1,.16-2.06,2.14,2.14,0,0,1,1.05-.88c.31-.11.49-.1.5-.07a3.09,3.09,0,0,0-1.24,1.14,1.76,1.76,0,0,0,0,1.66,1.87,1.87,0,0,0,1.69,1,1.77,1.77,0,0,0,1.5-1.25,1.48,1.48,0,0,0-.43-1.55A2.26,2.26,0,0,0,395,306.47Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "395.321px 308.22px 0px"
    },
    id: "elbmuk31kyifh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.68,295c.05.06-.54.51-1.26,1.42a9.16,9.16,0,0,0-1.88,4,9.29,9.29,0,0,0,.32,4.44c.36,1.11.75,1.73.68,1.78a4.18,4.18,0,0,1-1-1.65,8.5,8.5,0,0,1-.49-4.67,8.39,8.39,0,0,1,2.11-4.18A3.86,3.86,0,0,1,396.68,295Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "394.801px 300.82px 0px"
    },
    id: "elikvgqcuq21",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.56,322.48a5.23,5.23,0,0,1-1.29-1.68,12.29,12.29,0,0,1-1.56-4.9,12.11,12.11,0,0,1,.06-2.84,4.45,4.45,0,0,1,.89-2.2A2.67,2.67,0,0,1,395,310c.38-.09.59,0,.59,0a3.15,3.15,0,0,0-1.63,1.12c-.75,1-.89,2.84-.72,4.76a14.29,14.29,0,0,0,1.36,4.77C395.15,321.78,395.63,322.43,395.56,322.48Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "394.122px 316.22px 0px"
    },
    id: "el0m94nlo1nqqj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.54,308c-.11-.09.77-.89,2.14-.89s2.25.78,2.14.88a19.43,19.43,0,0,0-2.14-.35A20.92,20.92,0,0,0,388.54,308Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "390.68px 307.555px 0px"
    },
    id: "elcs5dxodlzn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.18,306.47s.15-.13.48-.16a2,2,0,0,1,1.31.46,1.91,1.91,0,0,1,.64,2,2.22,2.22,0,0,1-1.93,1.63,2.3,2.3,0,0,1-2.15-1.33,2.13,2.13,0,0,1,.15-2.06,2.2,2.2,0,0,1,1.06-.88c.31-.11.49-.1.5-.07a3.09,3.09,0,0,0-1.24,1.14,1.76,1.76,0,0,0,0,1.66,1.87,1.87,0,0,0,1.69,1,1.78,1.78,0,0,0,1.5-1.25,1.48,1.48,0,0,0-.43-1.55A2.28,2.28,0,0,0,366.18,306.47Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "366.507px 308.22px 0px"
    },
    id: "elwyzi0ytkfj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.85,295c0,.06-.54.51-1.27,1.42a8.9,8.9,0,0,0-1.55,8.48c.36,1.11.75,1.73.68,1.78a4.05,4.05,0,0,1-1-1.65,8.31,8.31,0,0,1,1.62-8.85A3.86,3.86,0,0,1,367.85,295Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "365.966px 300.84px 0px"
    },
    id: "elxf28u58mw5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.73,322.48a5.23,5.23,0,0,1-1.29-1.68,12.19,12.19,0,0,1-1.5-7.74,4.45,4.45,0,0,1,.89-2.2,2.59,2.59,0,0,1,1.33-.88c.37-.09.59,0,.59,0a3.11,3.11,0,0,0-1.63,1.12c-.75,1-.89,2.84-.72,4.76a14.06,14.06,0,0,0,1.36,4.77C366.32,321.78,366.8,322.43,366.73,322.48Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "365.287px 316.21px 0px"
    },
    id: "el4n3mrqeyjsf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.71,308c-.11-.09.77-.89,2.14-.89s2.25.78,2.14.88a19.43,19.43,0,0,0-2.14-.35A20.33,20.33,0,0,0,359.71,308Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "361.85px 307.555px 0px"
    },
    id: "elj5nncgslh0q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.4,349.39s-29.4-7.6-34.72,2.4-6.25,78.94-6.25,78.94,42.45,1.57,42.55-.22S442.4,349.39,442.4,349.39Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "422.707px 388.996px 0px"
    },
    id: "eluhg184a1bj7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,349.07s-19.41-5-24.71,2.39-6.7,79.62-6.7,79.62,31,.91,31.61.29S444,349.07,444,349.07Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "428.509px 389.501px 0px"
    },
    id: "el3dxdp01yi3f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.61,385.06s.07-.18.37-.22a1,1,0,0,1,1,.63,3,3,0,0,1,.19,1.65,1.67,1.67,0,0,1-.47,1,1.36,1.36,0,0,1-1.14.31,1.54,1.54,0,0,1-1.2-1,2,2,0,0,1,0-1.36,2.64,2.64,0,0,1,1.26-1.35l0,.21c-.32-.15-.49-.24-.47-.28s.2,0,.55.05l.21.05-.18.16a3,3,0,0,0-1,1.31,1.27,1.27,0,0,0,.84,1.72.9.9,0,0,0,1.05-.83,3.19,3.19,0,0,0-.05-1.43.81.81,0,0,0-.64-.56C432.76,385,432.64,385.09,432.61,385.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "432.726px 386.543px 0px"
    },
    id: "elig3n0wnwyp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.09,372a7.72,7.72,0,0,1,1.23,1.74,38,38,0,0,1,2.36,4.59,38.57,38.57,0,0,1,1.74,4.86,7.86,7.86,0,0,1,.44,2.09c-.16,0-1.06-3.08-2.66-6.74S427,372,427.09,372Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "429.973px 378.64px 0px"
    },
    id: "el4r3abgkiub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.68,373.17c.13.07-1.19,2.76-2.64,6.14s-2.52,6.17-2.66,6.12a43.91,43.91,0,0,1,5.3-12.26Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "436.034px 379.3px 0px"
    },
    id: "elxhpk4bdn7xk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.22,408.56a16.65,16.65,0,0,1,.34-3.09c.29-1.9.77-4.5,1.41-7.36s1.33-5.41,1.88-7.25a16.36,16.36,0,0,1,1-2.93,20,20,0,0,1-.66,3c-.46,1.86-1.09,4.42-1.73,7.27s-1.18,5.43-1.56,7.3A20.61,20.61,0,0,1,427.22,408.56Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "429.535px 398.245px 0px"
    },
    id: "elnto7sv48hko",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.65,400.65c-.15,0-1-2.91-2.41-6.39s-2.88-6.19-2.75-6.26a6.36,6.36,0,0,1,1.12,1.68,38.07,38.07,0,0,1,2.11,4.38,39.16,39.16,0,0,1,1.56,4.6A6.54,6.54,0,0,1,438.65,400.65Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "436.066px 394.325px 0px"
    },
    id: "el8b1m5agx78d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elx1ehqsrfxmd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.31,
    y: 229.61,
    width: 38.8,
    height: 48.53,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "120.71px 253.875px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eltidrvbxkzkb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.72,
    y: 231.31,
    width: 33.91,
    height: 45.12,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "120.675px 253.87px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "97.88 270.51 113.93 249.65 123.5 262.98 130.23 256.02 142.99 271.15 97.88 270.51",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "120.435px 260.4px 0px"
    },
    id: "elqkd2zimh89",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.87,247.27a3.55,3.55,0,1,1-3.5-3.6A3.54,3.54,0,0,1,127.87,247.27Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "124.32px 247.22px 0px"
    },
    id: "el731o2ctjl18",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9cdnh9e1bvm"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 36.65,
    width: 49.97,
    height: 62.5,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "81.485px 67.9px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "els9qu33jh05s"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.6,
    y: 38.84,
    width: 43.67,
    height: 58.11,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "81.435px 67.895px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "52.08 89.31 72.76 62.46 85.08 79.62 93.74 70.67 110.18 90.14 52.08 89.31",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "81.13px 76.3px 0px"
    },
    id: "eljswe7k2f7nr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.71,59.39a4.58,4.58,0,1,1-4.51-4.64A4.57,4.57,0,0,1,90.71,59.39Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "86.1304px 59.3295px 0px"
    },
    id: "elod95xwwjeue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwqr6zsu3i9c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.2,
    y: 49.93,
    width: 54.83,
    height: 68.58,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "402.615px 84.22px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el03jwcm0pihiv"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 378.6,
    y: 52.34,
    width: 47.93,
    height: 63.76,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "402.565px 84.22px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "370.35 107.73 393.04 78.26 406.57 97.09 416.07 87.26 434.1 108.64 370.35 107.73",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "402.225px 93.45px 0px"
    },
    id: "el7skrcymjtv7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.74,74.89a5,5,0,1,1-4.95-5.09A5,5,0,0,1,412.74,74.89Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "407.741px 74.7998px 0px"
    },
    id: "el04hp1byec6wg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmrdmniybvz"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.06,
    y: 261.38,
    width: 52.66,
    height: 65.87,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "288.39px 294.315px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0pji9d31kpr"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.33,
    y: 263.69,
    width: 46.03,
    height: 61.24,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "288.345px 294.31px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "257.4 316.88 279.2 288.58 292.19 306.67 301.31 297.23 318.63 317.76 257.4 316.88",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "288.015px 303.17px 0px"
    },
    id: "elmwmrqjde89a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.12,285.35a4.82,4.82,0,1,1-4.75-4.89A4.82,4.82,0,0,1,298.12,285.35Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "293.301px 285.279px 0px"
    },
    id: "el8xxvym5bxwx",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    style: {
      transformOrigin: "250px 466.495px 0px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.62,466.49c0,.16-95.65.28-213.61.28s-213.63-.12-213.63-.28,95.63-.27,213.63-.27S463.62,466.34,463.62,466.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250px 466.495px 0px"
    },
    id: "eleszhelmpn8m",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Images--inject-2",
    style: {
      transformOrigin: "257.158px 147.06px 0px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "el0pcqiqhe8e29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.01,
    y: 129.62,
    width: 65.51,
    height: 81.94,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "374.765px 170.59px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M416.2,138.42h-1.55l-4.45,0-16.78-.18-59.16-.73.24-.22c-.27,19.49-.58,41.84-.91,65.49h0l-.26-.27,81.94,1.22-.22.21c.33-19.72.6-36.06.79-47.5.1-5.72.19-10.2.24-13.28,0-1.52.06-2.69.08-3.5s0-1.22,0-1.22,0,.39,0,1.17,0,2,0,3.47c0,3.06-.07,7.53-.13,13.23-.14,11.47-.33,27.86-.57,47.64v.22h-.22L333.33,203h-.26v-.26h0c.35-23.65.68-46,1-65.49V137h.23l59.3,1,16.73.3,4.4.09,1.13,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "374.635px 170.585px 0px"
    },
    id: "elzo1nlump3bs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnlpcdy8nte"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 346.08,
    y: 132.5,
    width: 57.26,
    height: 76.19,
    style: {
      fill: "rgb(current)",
      transformOrigin: "374.71px 170.595px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "336.21 198.67 363.33 163.46 379.49 185.96 390.84 174.22 412.39 199.76 336.21 198.67",
    style: {
      fill: "rgb(current)",
      transformOrigin: "374.3px 181.61px 0px"
    },
    id: "eltzc6ongx31",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.87,159.44a6,6,0,1,1-5.91-6.09A6,6,0,0,1,386.87,159.44Z",
    style: {
      fill: "rgb(current)",
      transformOrigin: "380.871px 159.349px 0px"
    },
    id: "elfkyhf9m7vt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eliz5rsi1cb1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "336.21 198.67 363.33 163.46 379.49 185.96 390.84 174.22 412.39 199.76 336.21 198.67",
    style: {
      opacity: 0.2,
      transformOrigin: "374.3px 181.61px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqz8yyqzgwig"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "380.871px 159.349px 0px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.87,159.44a6,6,0,1,1-5.91-6.09A6,6,0,0,1,386.87,159.44Z",
    id: "el903mb4xt6t5",
    style: {
      transformOrigin: "380.871px 159.349px 0px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eloxjoki5e89h"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.85,
    y: 32.46,
    width: 78.08,
    height: 97.66,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "225.89px 81.29px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M275.27,43h-1.84l-5.3-.05-20-.22-70.52-.89.24-.23c-.33,23.23-.7,49.87-1.09,78.06h0l-.26-.27,97.65,1.44-.22.22c.38-23.52.7-43,.92-56.63.12-6.82.22-12.16.29-15.82,0-1.82.06-3.22.08-4.17s0-1.45,0-1.45,0,.47,0,1.4l0,4.13c0,3.65-.09,9-.17,15.78-.16,13.66-.4,33.19-.69,56.76v.22h-.21l-97.65-1.35h-.26v-.26h0c.41-28.19.8-54.82,1.14-78.06v-.23h.24l70.66,1.13,19.94.34,5.26.11,1.34,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "225.755px 81.33px 0px"
    },
    id: "el8onbqbv0btn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljypf94gqosn"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.22,
    y: 35.88,
    width: 68.25,
    height: 90.8,
    style: {
      fill: "rgb(current)",
      transformOrigin: "225.345px 81.28px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elokt9fx1czk"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.22,
    y: 35.88,
    width: 68.25,
    height: 90.8,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "225.345px 81.28px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "179.95 114.76 212.26 72.79 231.53 99.61 245.05 85.61 270.74 116.05 179.95 114.76",
    style: {
      fill: "rgb(current)",
      transformOrigin: "225.345px 94.42px 0px"
    },
    id: "elm82xgzwtiaa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhnnkma8csj8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 233.17,
    cy: 67.89,
    r: 7.15,
    style: {
      fill: "rgb(current)",
      transformOrigin: "233.17px 67.89px 0px",
      transform: "rotate(-7.77deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el05jw0fzm8wnw"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.57,
    y: 215.74,
    width: 32.51,
    height: 40.67,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "353.825px 236.075px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M374.39,220.11h-3l-8.34-.06-29.32-.3.24-.23c-.13,9.68-.28,20.77-.44,32.5l-.25-.26h1.4l1.4,0,2.78,0,5.48.08,10.55.16,19,.31-.21.21c.18-9.76.34-17.85.44-23.54.07-2.82.12-5.05.15-6.6,0-.74,0-1.33.05-1.75s0-.62,0-.62,0,.19,0,.57v1.71c0,1.54,0,3.75,0,6.56-.05,5.72-.13,13.86-.22,23.68v.21h-.22l-19.05-.24-10.55-.14-5.47-.08-2.79,0-1.4,0h-1.4c.23.24-.32-.32-.26-.27.18-11.73.34-22.82.49-32.5v-.23h.24l29.47.54,8.28.18,2.18.06.55,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "353.673px 236.01px 0px"
    },
    id: "el7x9yxlnrzpu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elx3rzfjxlh8q"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.38,
    y: 217.17,
    width: 28.42,
    height: 37.81,
    style: {
      fill: "rgb(current)",
      transformOrigin: "353.59px 236.075px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elc448xcnibr7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.38,
    y: 217.17,
    width: 28.42,
    height: 37.81,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "353.59px 236.075px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "334.69 250.01 348.15 232.54 356.17 243.71 361.8 237.88 372.5 250.56 334.69 250.01",
    style: {
      fill: "rgb(current)",
      transformOrigin: "353.595px 241.55px 0px"
    },
    id: "eljra9kjfbu8d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.83,230.54a3,3,0,1,1-2.93-3A3,3,0,0,1,359.83,230.54Z",
    style: {
      fill: "rgb(current)",
      transformOrigin: "356.83px 230.539px 0px"
    },
    id: "elz9itmrdl54",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2hdh0rrrccg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.42,
    y: 101.89,
    width: 45.12,
    height: 56.44,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "126.98px 130.11px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.52,108h-1.08l-3.07,0-11.56-.1-40.73-.47.24-.22c-.18,13.43-.39,28.82-.62,45.11.06.06-.48-.5-.24-.26h1l1,0,1.94,0,3.86.06,7.61.11,14.64.22,26.43.41-.22.21c.24-13.56.44-24.81.58-32.69.08-3.93.14-7,.18-9.16,0-1,.05-1.85.06-2.42s0-.84,0-.84,0,.26,0,.8,0,1.35,0,2.38c0,2.12,0,5.19-.07,9.1-.09,7.92-.21,19.22-.36,32.84v.21h-.22L128.44,153l-14.64-.21-7.6-.1-3.87-.06-1.94,0-1,0h-1c.22.23-.33-.32-.27-.27.25-16.29.47-31.68.67-45.11v-.24h.23l40.87.7,11.51.23,3,.07.77,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "126.83px 130.15px 0px"
    },
    id: "elrnf9g2m2i6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcrld37ijg9b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.22,
    y: 103.88,
    width: 39.44,
    height: 52.47,
    style: {
      fill: "rgb(current)",
      transformOrigin: "126.94px 130.115px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "100.43 149.46 119.1 125.2 130.24 140.7 138.05 132.61 152.9 150.21 100.43 149.46",
    style: {
      fill: "rgb(current)",
      transformOrigin: "126.665px 137.705px 0px"
    },
    id: "elm7ppwzwsgp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.32,122.43a4.13,4.13,0,1,1-4.07-4.19A4.13,4.13,0,0,1,135.32,122.43Z",
    style: {
      fill: "rgb(current)",
      transformOrigin: "131.19px 122.37px 0px"
    },
    id: "ely978wzzhax",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2yl7h8qpiv6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "100.43 149.46 119.1 125.2 130.24 140.7 138.05 132.61 152.9 150.21 100.43 149.46",
    style: {
      opacity: 0.1,
      transformOrigin: "126.665px 137.705px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elubwxvlq7ei"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "131.19px 122.37px 0px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.32,122.43a4.13,4.13,0,1,1-4.07-4.19A4.13,4.13,0,0,1,135.32,122.43Z",
    id: "el4mlsh06xg8n",
    style: {
      transformOrigin: "131.19px 122.37px 0px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eljnw6v30y5rk"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 293.39,
    y: 88.22,
    width: 30.13,
    height: 37.69,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "308.455px 107.065px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.52,92.27a.58.58,0,0,1-.19,0h-2.6L317,92.24,289.83,92l.23-.23c-.12,9-.25,19.25-.4,30.12l-.25-.26h1.3l1.3,0,2.58,0,5.07.07,9.78.15,17.65.29-.22.21c.18-9,.32-16.54.43-21.81.06-2.62.11-4.68.14-6.12,0-.69,0-1.23.05-1.63s0-.57,0-.57a4.89,4.89,0,0,1,0,.53v1.58c0,1.43,0,3.48,0,6.07-.05,5.31-.12,12.86-.2,22v.22h-.21l-17.65-.22-9.78-.13-5.08-.07-2.58,0-1.3,0h-1.3l-.26-.26c.17-10.88.32-21.16.46-30.13V91.5h.24l27.31.51,7.68.17,2,0,.51,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "308.325px 107.06px 0px"
    },
    id: "el4q5bai8odkn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0wqz5bc79o4r"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295.27,
    y: 89.54,
    width: 26.34,
    height: 35.04,
    style: {
      fill: "rgb(current)",
      transformOrigin: "308.44px 107.06px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "290.73 119.98 303.2 103.79 310.63 114.14 315.86 108.74 325.77 120.49 290.73 119.98",
    style: {
      fill: "rgb(current)",
      transformOrigin: "308.25px 112.14px 0px"
    },
    id: "elzjpu63b1n8n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,101.94a2.76,2.76,0,1,1-2.72-2.8A2.77,2.77,0,0,1,314,101.94Z",
    style: {
      fill: "rgb(current)",
      transformOrigin: "311.24px 101.9px 0px"
    },
    id: "ellh3o41ee8yh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgn2mrcay5k"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "290.73 119.98 303.2 103.79 310.63 114.14 315.86 108.74 325.77 120.49 290.73 119.98",
    style: {
      opacity: 0.1,
      transformOrigin: "308.25px 112.14px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellf2b8orjh1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "311.24px 101.9px 0px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314,101.94a2.76,2.76,0,1,1-2.72-2.8A2.77,2.77,0,0,1,314,101.94Z",
    id: "elig77bmfxet",
    style: {
      transformOrigin: "311.24px 101.9px 0px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el4q6i2zwyxge"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.98,
    y: 119.53,
    width: 117,
    height: 146.35,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "244.48px 192.705px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M318.48,135.25h-.7l-2,0-7.93-.08-29.94-.37L172.15,133.4l.23-.23c-.49,34.81-1,74.73-1.64,117h0l-.26-.26L316.81,252l-.22.22c.55-35.25,1-64.47,1.33-84.89.17-10.22.3-18.23.39-23.7.05-2.73.09-4.82.12-6.24s.05-2.16.05-2.16,0,.71,0,2.11,0,3.49-.06,6.21c-.06,5.45-.16,13.45-.28,23.65-.27,20.45-.65,49.71-1.1,85v.22h-.21l-146.34-2.05h-.26v-.28c.61-42.23,1.19-82.15,1.7-117v-.23h.23L278,134.56l29.89.49,7.89.14,2,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "244.355px 192.64px 0px"
    },
    id: "el50vmkak6ok",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwi1s95yxtbh"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.25,
    y: 124.67,
    width: 102.27,
    height: 136.06,
    style: {
      fill: "rgb(current)",
      transformOrigin: "244.385px 192.7px 0px",
      transform: "rotate(-89.18deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eluy2o1brzrr"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "175.63 242.86 224.06 179.97 252.92 220.16 273.19 199.19 311.68 244.8 175.63 242.86",
    style: {
      opacity: 0.2,
      transformOrigin: "243.655px 212.385px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elm8epv3lyb8"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "255.381px 172.639px 0px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.1,172.79a10.72,10.72,0,1,1-10.56-10.87A10.73,10.73,0,0,1,266.1,172.79Z",
    id: "elye6qagfxpmm",
    style: {
      transformOrigin: "255.381px 172.639px 0px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    style: {
      transformOrigin: "170.955px 327.955px 0px"
    },
    className: "animable animator-active"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.05,291.31l-1.74-1.4v-.16l-.07.09-11.46-9.2,4.92-8.1-11.86-8.66c0,.58-11,17-9.51,20.18,2.12,4.55,16.48,13.64,22.36,17.23a35.24,35.24,0,0,0-4.75.93c-1.5.49,3.39,1.79,4.57,2,.46.09,1.41-.64,2.41-1.62l.28.16.31-.74a33.32,33.32,0,0,0,3-3.52,12.23,12.23,0,0,0,.15-3.94Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "143.121px 284.054px 0px"
    },
    id: "elzs7nie4ezi9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.44,287.28l1.74-1.39,0-.16.07.09,13.11-8.37-12.66-10.28,10.95-9.5c8.46,6,19.77,13.81,16.5,22.36-1.78,4.69-16.47,13.65-22.35,17.23a37.54,37.54,0,0,1,4.75.94c1.49.49-3.39,1.78-4.57,2-.46.1-1.41-.64-2.42-1.61l-.27.16L198,298a33.54,33.54,0,0,1-3-3.52,12.61,12.61,0,0,1-.14-3.93Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "208.584px 278.94px 0px"
    },
    id: "el0w5v1rh4vq2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.93,248.47h0a8.14,8.14,0,0,0,8.74-7.8c.17-4.42.32-8.89.32-8.89s6.7-.63,7.19-7.27.26-21.95.26-21.95h0a23.11,23.11,0,0,0-23.36,1.5l-1,.7.37,35.69A8.14,8.14,0,0,0,172.93,248.47Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "177.287px 224.289px 0px"
    },
    id: "elid78w95qsj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.62,193.94c-4-.12-7.7,2.52-9.57,5.77s-2.28,7-2.46,10.67a204.19,204.19,0,0,0,.51,21.56,2.3,2.3,0,0,0,.46,1.51,2.89,2.89,0,0,0,1.75.66,136.15,136.15,0,0,0,37,.06c.81-1.46-.32-3.2-1.63-4.32s-2.93-2.15-3.4-3.72c-.74-2.48,1.72-5.14.76-7.56-.72-1.82-3.11-2.71-3.95-4.49-1.41-3,2.23-6.59.61-9.48-.84-1.51-2.81-2.18-4-3.44-1.1-1.11-1.58-2.62-2.53-3.84a9.75,9.75,0,0,0-6.62-3.23,24.51,24.51,0,0,0-6.84-.15",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "180.543px 214.586px 0px"
    },
    id: "elb5pyltlo5hn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.16,201.53c-1.71.84-2.45,2.88-2.7,4.77s-.18,3.88-1,5.61-2.59,3.27-3.05,5.26c-.6,2.57,1.1,5.61-.43,7.77-1,1.39-2.93,1.74-4.15,2.93-1.68,1.65-1.53,4.36-1.26,6.7l22.15-.19",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "161.562px 218.05px 0px"
    },
    id: "elswl4m0ecrto",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.18,199.2a4.9,4.9,0,0,0,4.85-4.84,5.53,5.53,0,0,0-4.79-5.15,6.35,6.35,0,0,0-6.24,3.56,4.67,4.67,0,0,0-.37,3.41,4.72,4.72,0,0,0,2.26,2.58,7.11,7.11,0,0,0,6.91,0",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "170.247px 194.422px 0px"
    },
    id: "elhxqde9zuanw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.56,194.92a2.88,2.88,0,0,1-.28,1.71,5.61,5.61,0,0,1-7.05,3.23c-1-.37-1.52-.86-1.48-.9s.59.29,1.58.54a5.65,5.65,0,0,0,6.61-3C175.4,195.56,175.47,194.9,175.56,194.92Z",
    style: {
      fill: "rgb(current)",
      transformOrigin: "171.169px 197.545px 0px"
    },
    id: "elwpj7d89izst",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.54,272.12l-5.51-5.9-1.82,8.7.38,6.76c0,.34,7.19,18.1,7.19,18.1a43.58,43.58,0,0,1,3.45,21.44l-52.66-1.53s.77-15.33,6.69-25.36c2.7-4.59,2-11.51.75-16.76-.4-1.66-.93-4.4-1.14-6.1l0-.29L153.11,276l-16.49-11.91c5.36-10.33,13.22-20.77,14.16-21.55A19.44,19.44,0,0,1,163,238l20.51.18a16.44,16.44,0,0,1,3.19.65c2.51.18,6.95,2.3,11.87,7,4.15,4,8.77,8.8,13.65,12.36l-13.7,13.88",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "174.42px 279.61px 0px"
    },
    id: "elz0vqoc4hdx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.38,238.62s.12.08.33.29a8.55,8.55,0,0,1,.78,1,9.51,9.51,0,0,1,1.68,4.26,7.62,7.62,0,0,1-2,6.38,6.67,6.67,0,0,1-3.55,2c-1.43.29-2.88,0-4.27.24a3.69,3.69,0,0,0-1.84.79,5.14,5.14,0,0,0-1.2,1.6c-.64,1.19-1,2.49-1.77,3.59a4.3,4.3,0,0,1-1.37,1.38,3.42,3.42,0,0,1-1.79.46,7,7,0,0,1-3.07-.9,11.26,11.26,0,0,1-3.55-2.9,9.47,9.47,0,0,1-.71-1c-.14-.24-.21-.38-.19-.39s.35.49,1.06,1.28a11.74,11.74,0,0,0,3.55,2.7,6.77,6.77,0,0,0,2.91.8,3,3,0,0,0,1.56-.42,4.11,4.11,0,0,0,1.2-1.25c.67-1,1.06-2.32,1.71-3.57a5.81,5.81,0,0,1,1.32-1.75,4.2,4.2,0,0,1,2.09-.92c1.52-.22,3,.05,4.26-.22a6.3,6.3,0,0,0,3.3-1.82,7.29,7.29,0,0,0,1.76-3,7.63,7.63,0,0,0,.27-3,10.11,10.11,0,0,0-1.48-4.19C164.76,239.08,164.34,238.65,164.38,238.62Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "154.556px 249.615px 0px"
    },
    id: "elbr5muc0gqf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.16,261.54a1.76,1.76,0,0,1,.9-.2,3.94,3.94,0,0,1,2.39.8,3.85,3.85,0,0,1,1.15,1.35,3.45,3.45,0,0,1,.35,2,3.89,3.89,0,0,1-7.12,1.84,3.54,3.54,0,0,1-.68-1.94,3.88,3.88,0,0,1,.36-1.75,3.83,3.83,0,0,1,1.7-1.85,1.84,1.84,0,0,1,.88-.27c0,.05-.3.14-.77.45a3.94,3.94,0,0,0-1.48,1.82,3.31,3.31,0,0,0,.37,3.26,3.44,3.44,0,0,0,6.27-1.62,3.3,3.3,0,0,0-1.26-3,4,4,0,0,0-2.17-.88C166.49,261.51,166.17,261.58,166.16,261.54Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "167.063px 265.205px 0px"
    },
    id: "eliqgym7kaet",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.25,251.46a7.07,7.07,0,0,1-1.26.7,22.57,22.57,0,0,1-3.64,1.47,9.86,9.86,0,0,1-5.84,0,6.43,6.43,0,0,1-2.93-1.94c-.79-.95-1.28-2.11-2.05-3a3.19,3.19,0,0,0-1.36-1,3.9,3.9,0,0,0-1.67-.16,12.58,12.58,0,0,1-3.46.21,5.8,5.8,0,0,1-4.47-3.62,5.74,5.74,0,0,1,0-3.93,5,5,0,0,1,.48-1c.14-.2.22-.3.24-.29a13.64,13.64,0,0,0-.53,1.32,5.79,5.79,0,0,0,.17,3.73,5.47,5.47,0,0,0,4.21,3.27,11.88,11.88,0,0,0,3.34-.24,4.32,4.32,0,0,1,1.9.19,3.71,3.71,0,0,1,1.58,1.19c.83,1,1.31,2.17,2,3.05a6,6,0,0,0,2.69,1.8,9.57,9.57,0,0,0,5.58.07,28.46,28.46,0,0,0,3.66-1.29A8.42,8.42,0,0,1,203.25,251.46Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "189.737px 246.486px 0px"
    },
    id: "eloeq9mp5xwwc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,291.8a.66.66,0,0,1-.07.15c-.06.09-.14.23-.26.4a6.41,6.41,0,0,1-1.29,1.29,6.9,6.9,0,0,1-2.64,1.22,6.67,6.67,0,0,1-3.82-.32,7.1,7.1,0,0,1-3.54-3c-.9-1.38-1.6-3.12-3.13-4a8.29,8.29,0,0,0-2.65-.79,5.58,5.58,0,0,1-2.82-1.21,5.37,5.37,0,0,1-1.39-6A7,7,0,0,1,176.5,277c.84-.65,1.72-1.2,2.47-1.84a5.19,5.19,0,0,0,1.7-2.24,6.39,6.39,0,0,0,.16-2.72,22.89,22.89,0,0,1-.25-2.73,4.71,4.71,0,0,1,.72-2.56,5.6,5.6,0,0,1,4-2.34,6.5,6.5,0,0,1,3.77.73,9.63,9.63,0,0,1,2.35,1.69,11.35,11.35,0,0,1,1.2,1.36,3.51,3.51,0,0,1,.36.53s-.54-.69-1.7-1.74a10,10,0,0,0-2.34-1.58,6.25,6.25,0,0,0-3.59-.62,5.19,5.19,0,0,0-3.69,2.21,4.22,4.22,0,0,0-.62,2.32,26.32,26.32,0,0,0,.26,2.68,6.67,6.67,0,0,1-.16,2.93,5.64,5.64,0,0,1-1.84,2.47c-.79.67-1.67,1.22-2.48,1.86a6.4,6.4,0,0,0-2,2.27,4.83,4.83,0,0,0,1.25,5.42c1.43,1.36,3.65,1,5.37,2a6.05,6.05,0,0,1,1.95,2c.48.75.88,1.51,1.31,2.21a6.79,6.79,0,0,0,3.3,2.9,6.41,6.41,0,0,0,3.63.37,6.78,6.78,0,0,0,2.58-1.09A9.24,9.24,0,0,0,196,291.8Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "185px 278.768px 0px"
    },
    id: "els6en2lcgl6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.34,303.9a2.19,2.19,0,0,0,.53-1,3.54,3.54,0,0,0-1.15-2.89,9.42,9.42,0,0,1-1.42-1.88,5.12,5.12,0,0,1-.47-2.69c.1-1.92,1-3.87.77-5.95a3.41,3.41,0,0,0-1.29-2.52,4.24,4.24,0,0,0-2.63-.66c-1.8.09-3.42.76-4.87.78a4.35,4.35,0,0,1-3.2-1.05,2.38,2.38,0,0,1-.54-.75c-.09-.2-.11-.31-.09-.31a4.86,4.86,0,0,0,.77.91,4.21,4.21,0,0,0,3,.83c1.38-.06,2.94-.75,4.87-.89a4.65,4.65,0,0,1,3,.73,3.94,3.94,0,0,1,1.51,2.88c.21,2.27-.71,4.23-.81,6a4.75,4.75,0,0,0,.38,2.47,9.71,9.71,0,0,0,1.31,1.83,5.12,5.12,0,0,1,1,1.69,2.94,2.94,0,0,1,.08,1.48C172.85,303.73,172.32,303.92,172.34,303.9Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "165.561px 294.441px 0px"
    },
    id: "eloydv8svsxs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.44,308.82c-1,1.5-40.32,149.62-40.32,149.62L125,462.82,178,322Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "144.56px 385.82px 0px"
    },
    id: "el44ce0jwgjrm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.39 320.67 204.59 461.6 220.65 462.24 202.22 313.21 175.39 320.67",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "198.02px 387.725px 0px"
    },
    id: "elqbld0xap8jc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.18,303.57,123.07,407.48l21.48,8.89L175.4,329l18.68,90.9,22.53-4.44L201.26,305.21l-2.1-.28a10.68,10.68,0,0,0-3.82.2l-1.4.34a10.29,10.29,0,0,1-4.84,0l-1-.24a10.4,10.4,0,0,0-4.51-.06l-2.49.51a10.32,10.32,0,0,1-5.51-.35l-2.48-.85a10.41,10.41,0,0,0-5.22-.41l-2.35.42a10.45,10.45,0,0,1-3.94-.06l-4-.82a13.9,13.9,0,0,0-5-.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "169.84px 361.61px 0px"
    },
    id: "elhlhha9w2rv8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.43,323.33a6.23,6.23,0,0,1-1.32.37c-.86.2-2.11.46-3.65.77-3.09.62-7.37,1.38-12.13,2.06s-9.08,1.16-12.22,1.43c-1.57.14-2.84.24-3.72.28a6.28,6.28,0,0,1-1.37,0,7.91,7.91,0,0,1,1.35-.22l3.7-.44c3.13-.37,7.44-.9,12.19-1.58s9-1.39,12.13-1.91l3.68-.61A7.8,7.8,0,0,1,191.43,323.33Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "174.225px 325.804px 0px"
    },
    id: "el97iv7duhens",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.61,462.21l-.07-1.68-17,.49.14,5.52,1.05,0c4.67.11,23.75.28,26.83-.68C236.05,464.82,221.61,462.21,221.61,462.21Z",
    style: {
      fill: "rgb(current)",
      transformOrigin: "218.822px 463.578px 0px"
    },
    id: "el9rmwzhbp44j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1n2knr4qzd"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "207.71px 464.148px 0px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.84,466.26a5.37,5.37,0,0,0-2.26-3.29,6,6,0,0,0-4-1l.13,4.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "207.71px 464.148px 0px"
    },
    id: "elpmzaihgxvy",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elhajkpta5iv"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "218.955px 465.221px 0px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.67,463.72s5.07,1.21,4.47,2-19.89,1.29-28.42.82l0-.35,22.5-.41S227.69,463.78,228.67,463.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "218.955px 465.221px 0px"
    },
    id: "elt5j9gekk62",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M204.48,466.19a1.51,1.51,0,0,0,.29,0l.83,0,3.07,0c2.6,0,6.19,0,10.14-.1s7.55-.27,10.14-.42l3.06-.2.84-.07a1.91,1.91,0,0,0,.28,0h-.29l-.83,0-3.07.14c-2.59.11-6.17.26-10.13.36s-7.54.14-10.14.15l-3.07,0h-.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "218.805px 465.798px 0px"
    },
    id: "elyi6po15lmpi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.24,466a6.13,6.13,0,0,1,.53-1.37,5.82,5.82,0,0,1,1-1.12,2.15,2.15,0,0,0-1.19,1A2,2,0,0,0,227.24,466Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "227.991px 464.755px 0px"
    },
    id: "elm604srrkukq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.19,463.8s.27-.24.51-.61.39-.69.34-.72-.28.25-.52.62S222.14,463.78,222.19,463.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "222.615px 463.134px 0px"
    },
    id: "el95hl0xa4aon",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.8,463.17s.3-.14.58-.39.48-.48.45-.52-.31.13-.59.39S220.76,463.13,220.8,463.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "221.314px 462.712px 0px"
    },
    id: "elfmddtaigtk6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.89,461.71a2.14,2.14,0,0,0,.88.08,2.2,2.2,0,0,0,.88-.11,2.11,2.11,0,0,0-.88-.08A2.2,2.2,0,0,0,219.89,461.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "220.77px 461.695px 0px"
    },
    id: "el5v1si3237yj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.56,460.67a2.66,2.66,0,0,0,2,.09,5.43,5.43,0,0,0-1,0A6.45,6.45,0,0,0,219.56,460.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "220.56px 460.792px 0px"
    },
    id: "el4miwhid73in",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.72,462.42a3.23,3.23,0,0,0,1.08,0,6.59,6.59,0,0,0,1.15-.26,3.9,3.9,0,0,0,.65-.27.52.52,0,0,0,.26-.32.39.39,0,0,0-.17-.4,2.07,2.07,0,0,0-2.45.6,1.76,1.76,0,0,0-.33.69.52.52,0,0,0,0,.27,2.69,2.69,0,0,1,.47-.87,1.85,1.85,0,0,1,.91-.59,1.8,1.8,0,0,1,1.29,0c.18.11.12.3-.07.41a2.87,2.87,0,0,1-.6.26,8.17,8.17,0,0,1-1.11.3C223.13,462.38,222.72,462.39,222.72,462.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "224.293px 461.862px 0px"
    },
    id: "elxsoroda6g8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,462.46a.89.89,0,0,0,.1-.7,1.55,1.55,0,0,0-.32-.73,1.08,1.08,0,0,0-.91-.49.39.39,0,0,0-.32.47,1,1,0,0,0,.19.45,3.22,3.22,0,0,0,.53.6,1.56,1.56,0,0,0,.64.39s-.22-.18-.53-.49a3.39,3.39,0,0,1-.48-.59c-.15-.21-.26-.59,0-.64s.55.21.72.4a1.67,1.67,0,0,1,.33.65A3.44,3.44,0,0,1,223,462.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "222.336px 461.5px 0px"
    },
    id: "elkzgnpceqw2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.69,461.88s.48-.05,1.25,0a5.72,5.72,0,0,1,2.75,1,5.11,5.11,0,0,1,1.77,2.19c.28.67.32,1.12.36,1.12a1.13,1.13,0,0,0,0-.32,4.81,4.81,0,0,0-.21-.84,4.91,4.91,0,0,0-1.79-2.3,5.4,5.4,0,0,0-2.86-.95,4,4,0,0,0-.93.05A1.12,1.12,0,0,0,204.69,461.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "207.761px 463.981px 0px"
    },
    id: "eloya4kz3azd8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.92,464.67a15,15,0,0,0,4.94-.09c0-.05-1.11,0-2.47.06S212.93,464.61,212.92,464.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "215.39px 464.696px 0px"
    },
    id: "el4mopiw6lzpg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.61,464.75s.1.22.22.45.19.44.24.43.08-.25-.06-.51S209.65,464.71,209.61,464.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "209.861px 465.187px 0px"
    },
    id: "el8t8jtk5tvis",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.32,463.34s.08.2.26.36.35.26.39.22-.07-.2-.25-.36S208.36,463.3,208.32,463.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.649px 463.63px 0px"
    },
    id: "el96h8gv5l58c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.52,462.73s.23,0,.48.12.44.19.48.16-.1-.25-.42-.34S206.5,462.68,206.52,462.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "207.003px 462.825px 0px"
    },
    id: "elgyep67k3cop",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.24,462.45c0,.05.08.13.22.18s.27,0,.29,0-.08-.13-.22-.17S205.25,462.4,205.24,462.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "205.496px 462.536px 0px"
    },
    id: "el81pl8ty36cj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.23 455.39 108.72 466.44 125.69 466.44 126.42 459.25 111.23 455.39",
    style: {
      fill: "rgb(current)",
      transformOrigin: "117.57px 460.915px 0px"
    },
    id: "el4vpzk8yugxv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,464.83a11,11,0,0,1-2.48.16c-1.53,0-3.64,0-6-.1l-6-.26a11.88,11.88,0,0,1-2.46-.22,11.3,11.3,0,0,1,2.47-.15c1.53,0,3.64,0,6,.11l5.95.26A13.21,13.21,0,0,1,126,464.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "117.53px 464.625px 0px"
    },
    id: "eltug9s95ohzp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.85,457.54a12.75,12.75,0,0,1,0,3.58,13,13,0,0,1-.5,3.55,11.89,11.89,0,0,1,0-3.58A12.13,12.13,0,0,1,118.85,457.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "118.595px 461.105px 0px"
    },
    id: "el5xn1dgptrz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el00v6ppybedjjo"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "108.72 466.44 125.69 466.44 125.85 464.83 109.03 464.42 108.72 466.25",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "117.285px 465.43px 0px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2",
    style: {
      transformOrigin: "123.95px 191.155px 0px"
    },
    className: "animable animator-hidden"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 122.21,
    cy: 191.15,
    r: 26.01,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "122.21px 191.15px 0px"
    },
    id: "eldscijq8atj9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.84 212.6 151.7 217.17 143.31 202.36 133.84 212.6",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "142.77px 209.765px 0px"
    },
    id: "el4bfdgpuwe0b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.25 189.05 111.44 193.53 121.22 201.64 135.38 187.59 131.25 183.92 120.94 193.87 115.25 189.05",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "123.41px 192.78px 0px"
    },
    id: "elvcx34qyjk5",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.04fa9c3a.svg";
export { ForwardRef as ReactComponent };